import React, { useState } from "react"
import Map from "./components/Map"
import { MapOriginIcon, ShadedMapMarkerIcon } from "../../Icons"
import "./MapField.css"
import googleApiKey from "../../utils/googleApiKey"

const MapField = ({
  type = "origin",
  field: { name },
  form: { values, errors, touched, setFieldValue, isSubmitting }
}) => {
  const [formattedAddress, setFormattedAddress] = useState("")
  return (
    <div className="Map">
      <div className="address">
        {(type === "origin" && <MapOriginIcon />) ||
          (type === "delivery" && <ShadedMapMarkerIcon />)}
        <span className="text-address">
          {formattedAddress
            ? formattedAddress
            : "Search for your location below"}
        </span>
      </div>
      <Map
        name={name}
        value={values[name]}
        setFormattedAddress={setFormattedAddress}
        setFieldValue={setFieldValue}
        isMarkerShown
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ width: `100%`, height: `400px` }} />}
        containerElement={
          <div style={{ width: `100%`, height: `400px`, margin: `20px 0` }} />
        }
        mapElement={<div style={{ width: `100%`, height: `400px` }} />}
        viewOnly={isSubmitting}
      />
      {touched[name] &&
        errors[name] && <div className="error-message">{errors[name]}</div>}
    </div>
  )
}

export default MapField
